<template>
  <div
    class="panoramica-status-header"
    :class="[
      headerClass,
      {
        'panoramica-status-header--lineare':
          mode_poker || mode_selvaggia || mode_bustachiusa || mode_assegna,
      },
    ]"
  >
    <div class="panoramica-status-main">
      <div class="panoramica-status-log-area">
        <div class="panoramica-status-log">
          <asta-log v-if="astaLogsLast" small :log="astaLogsLast"></asta-log>
          <div v-else class="panoramica-status-log-empty">Registro Eventi</div>
          <v-btn
            x-small
            icon
            outlined
            class="ml-1 white--text"
            @click="showAstaLogs"
          >
            <v-icon small>more_horiz</v-icon>
          </v-btn>
        </div>
      </div>

      <div class="panoramica-status-center">
        <calciatore-battuto
          v-if="calciatoreInAsta"
          :id="calciatoreInAsta"
          large
          class="panoramica-status-calciatore"
        ></calciatore-battuto>
      </div>

      <div class="panoramica-status-controls">
        <div
          v-if="showMiglioreOffertaArrow"
          class="panoramica-status-transfer-arrow"
        ></div>

        <v-card class="no-shadow pa-2" v-if="showMiglioreOfferta">
          <squadra-offerta
            :offerta="migliore_offerta.offerta"
            :uid="migliore_offerta.vincitore"
            :ifNoOfferta="'Nessuna offerta'"
            crediti-style="dark"
            variant="horizontal"
            class="panoramica-status-offerta"
            creditiGlow
          ></squadra-offerta>
        </v-card>

        <progress-countdown-display
          v-if="timerTimeLeft !== null"
          :time="timerTime"
          :time-left="timerTimeLeft"
          class="panoramica-status-timer mx-4"
        ></progress-countdown-display>
        <div v-if="showAssegnaHint" class="panoramica-assegna-hint">
          <v-icon x-small class="mr-1 white--text">touch_app</v-icon>
          {{ assegnaHintText }}
        </div>
        <component :is="actionsComponent"></component>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
import db from "../../js/db";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import mixins from "../../js/mixins";
import CalciatoreBattuto from "./CalciatoreBattuto";
import SquadraOfferta from "./SquadraOfferta";
import AstaLog from "./AstaLog";
import ProgressCountdownDisplay from "./ProgressCountdownDisplay";
import AstaPokerHeaderActions from "./AstaPokerHeaderActions";
import AstaSelvaggiaHeaderActions from "./AstaSelvaggiaHeaderActions";
import AstaBustaChiusaHeaderActions from "./AstaBustaChiusaHeaderActions";
import AstaAssegnaHeaderActions from "./AstaAssegnaHeaderActions";

export default {
  name: "panoramica-status-header",
  mixins: [mixins],
  components: {
    CalciatoreBattuto,
    SquadraOfferta,
    AstaLog,
    ProgressCountdownDisplay,
    AstaPokerHeaderActions,
    AstaSelvaggiaHeaderActions,
    AstaBustaChiusaHeaderActions,
    AstaAssegnaHeaderActions,
  },
  computed: {
    headerClass() {
      if (this.mode_poker) {
        return "yellow darken-2 white--text";
      }
      if (this.mode_selvaggia) {
        return {
          red:
            this.calciatoreInAsta &&
            this.migliore_offerta.vincitore &&
            !this.userHasPassed &&
            !this.userIsWinning,
          text:
            !this.calciatoreInAsta ||
            !this.migliore_offerta.vincitore ||
            this.userHasPassed,
          accent: this.userIsWinning,
          "white--text": true,
        };
      }
      if (this.mode_bustachiusa) {
        return {
          "yellow darken-2 white--text": !this.bustaOfferteCompletate,
          "text white--text": this.bustaOfferteCompletate,
        };
      }
      if (this.mode_assegna) {
        return "cyan darken-1 white--text";
      }
      return "navy darken-3 white--text";
    },
    // currentActor() {
    //   if (this.mode_poker && this.asta_round.speaker) {
    //     return {
    //       icon: "record_voice_over",
    //       label: "Offerta",
    //       name: this.squadraName(this.asta_round.speaker),
    //     };
    //   }
    //   if (this.asta_round.chooser) {
    //     return {
    //       icon: this.calciatoreInAsta ? "done" : "touch_app",
    //       label: this.calciatoreInAsta ? "Ha scelto" : "Sceglie",
    //       name: this.squadraName(this.asta_round.chooser),
    //     };
    //   }
    //   return null;
    // },
    timerTimeLeft() {
      if (
        this.mode_poker &&
        this.asta_round.speakerTimeLeft !== null &&
        this.asta_round.speakerTimeLeft !== undefined
      ) {
        return this.asta_round.speakerTimeLeft;
      }
      if (
        this.mode_selvaggia &&
        this.asta_selvaggia_time_left !== null &&
        this.asta_selvaggia_time_left !== undefined
      ) {
        return this.asta_selvaggia_time_left;
      }
      if (
        this.mode_bustachiusa &&
        this.showBustaChiusaTimer &&
        this.asta_busta_chiusa_time_left !== null &&
        this.asta_busta_chiusa_time_left !== undefined
      ) {
        return this.asta_busta_chiusa_time_left;
      }
      return null;
    },
    timerTime() {
      return this.asta_settings.timeout_s || 0;
    },
    showMiglioreOfferta() {
      if (!this.calciatoreInAsta || this.mode_assegna) {
        return false;
      }
      if (this.mode_bustachiusa) {
        return (
          this.asta_round.step &&
          this.asta_round.step.type == Constants.ROUND_STEP.BUSTE
        );
      }
      return this.mode_poker || this.mode_selvaggia;
    },
    showMiglioreOffertaArrow() {
      return this.showMiglioreOfferta && this.migliore_offerta.vincitore;
    },
    showAssegnaHint() {
      return this.mode_assegna && !this.is_calciatore_in_asta;
    },
    assegnaHintText() {
      return Helpers.assegnaHintText(this.mode_random, false);
    },
    actionsComponent() {
      if (this.mode_poker) {
        return "asta-poker-header-actions";
      }
      if (this.mode_selvaggia) {
        return "asta-selvaggia-header-actions";
      }
      if (this.mode_bustachiusa) {
        return "asta-busta-chiusa-header-actions";
      }
      if (this.mode_assegna) {
        return "asta-assegna-header-actions";
      }
      return null;
    },
    userIsWinning() {
      return this.migliore_offerta.vincitore == this.user_uid;
    },
    userHasPassed() {
      return (
        this.asta_round.offerte &&
        this.asta_round.offerte[this.user_uid] == Constants.OFFERTA.PASSO
      );
    },
    bustaOfferteCompletate() {
      return (
        this.asta_round.offerte &&
        Object.values(this.asta_round.offerte).every(
          (offerta) => offerta !== Constants.OFFERTA.INIT
        )
      );
    },
    showBustaChiusaTimer() {
      return (
        this.mode_bustachiusa &&
        this.calciatoreInAsta !== null &&
        this.calciatoreInAsta !== undefined &&
        this.running &&
        this.asta_round.step &&
        this.asta_round.step.type == Constants.ROUND_STEP.OFFERTE &&
        this.squadra(this.user_uid) &&
        this.squadra(this.user_uid).active &&
        this.bustaChiusaMiaOfferta === Constants.OFFERTA.INIT
      );
    },
    bustaChiusaMiaOfferta() {
      return this.asta_round.offerte && this.user_uid in this.asta_round.offerte
        ? this.asta_round.offerte[this.user_uid]
        : Constants.OFFERTA.INIT;
    },
    ...Vuex.mapGetters([
      "migliore_offerta",
      "astaLogsLast",
      "asta_selvaggia_time_left",
      "asta_busta_chiusa_time_left",
    ]),
  },
  methods: {
    squadraName(id) {
      const squadra = this.asta_squadre[id];
      return squadra ? squadra.name : id;
    },
    showAstaLogs() {
      db.emit("showAstaLogs");
    },
  },
};
</script>

<style lang="scss" scoped>
.panoramica-status-header {
  flex: 0 0 auto;
  position: relative;
  padding: 8px 8px;
  min-height: 60px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.22);
  z-index: 5;
  overflow: visible;
}

.panoramica-status-main {
  min-width: 0;
  min-height: 52px;
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 220px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
}

.panoramica-status-log-area,
.panoramica-status-controls {
  min-width: 0;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  justify-content: flex-start;
}

.panoramica-status-log-area {
  display: flex;
  grid-column: 1;
  justify-content: flex-start;
  z-index: 1;
}

.panoramica-status-center {
  grid-column: 2;
  align-self: center;
  justify-self: center;
  z-index: 2;
}

.panoramica-status-controls {
  display: flex;
  justify-content: flex-start;
  z-index: 1;
}

// .panoramica-status-header:not(.panoramica-status-header--lineare)
//   .panoramica-status-controls {
//   display: flex;
//   flex-direction: column;
//   gap: 4px;
// }

// .panoramica-status-header--lineare .panoramica-status-controls {
//   flex-direction: row;
//   align-items: center;
//   gap: 6px;
// }

.panoramica-status-transfer-arrow {
  flex: 0 0 auto;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-left: 14px solid rgba(255, 255, 255, 0.86);
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.35));
}

// .crediti-squadra-offerta {
//   display: flex;
//   align-items: center;
//   gap: 5px;
//   padding: 5px 10px;
// }

// .timer-controlli{
//   display: flex;
//   align-items: center;
//   gap: 5px;
//   flex-wrap: wrap;
// }

.panoramica-assegna-hint {
  font-size: 11px;
}

.panoramica-status-log,
.panoramica-actions-offerta,
.panoramica-assegna-hint,
::v-deep .panoramica-actions-waiting,
::v-deep .panoramica-poker-hint,
::v-deep .panoramica-selvaggia-hint,
::v-deep .panoramica-actions-esito,
::v-deep .panoramica-busta-hint {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 6px 10px;
}

.panoramica-status-title {
  font-size: 13px;
  line-height: 1;
  white-space: nowrap;
}

.panoramica-status-chip{
  // display: inline-flex;
  // align-items: center;
  // gap: 3px;
  // min-height: 22px;
  // padding: 0 6px;
  // font-size: 11px;
  // line-height: 1;
  // white-space: nowrap;
}

.panoramica-status-calciatore::v-deep.calciatore-battuto {
  flex: 0 0 auto;
  margin:  -23px auto -21px;
  box-shadow: 0px 2px 18px 7px rgb(0 0 0 / 18%);
}

.panoramica-status-log {
  width: fit-content;
  min-width: 0;
  max-width: min(360px, 100%);
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
  overflow: hidden;
}

.panoramica-status-log::v-deep .asta-log {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  font-size: 11px;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.panoramica-status-log .v-btn {
  flex: 0 0 auto;
}

.panoramica-status-log::v-deep .asta-log > div,
.panoramica-status-log::v-deep .asta-log > div * {
  color: #fff !important;
}

.panoramica-status-log-empty {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  opacity: 0.85;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .panoramica-status-header {
    padding: 5px 6px;
  }

  .panoramica-status-main {
    gap: 5px;
    grid-template-columns: minmax(0, 1fr) 180px minmax(0, 1fr);
  }

  .panoramica-status-title {
    font-size: 12px;
  }

  .panoramica-status-calciatore::v-deep.calciatore-battuto.large {
    width: 180px;
  }

  .panoramica-status-log {
    min-width: 0;
    max-width: 30vw;
  }
}
</style>
